import gql from "graphql-tag";

export interface IDynamicTextValidationItem {
    key: string;
    value: string;
}

export enum DynamicTextErrorType {
    SyntaxError = "SyntaxError",
    UnknownVariable = "UnknownVariable",
    UnknownMemberVariable = "UnknownMemberVariable",
    InaccessibleMemberVariable = "InaccessibleMemberVariable",
}

export interface IValidationError {
    type: DynamicTextErrorType;
    message: string;
    errorLine: string;
    property: string;
}

export interface IValidatedDynamicTextResult {
    key: string;
    errors: IValidationError[];
}

export interface IValidateDynamicText {
    validateDynamicText: IValidatedDynamicTextResult[];
}

export interface IValidateDynamicTextResponse {
    communication: IValidateDynamicText;
}

export const validateDynamicTextQuery = gql`
    query ValidateDynamicText($id:ID!, $context: DynamicTextContextEnum, $dictionaryToValidate: [KeyValuePairGraphTypeInput], $participantID: ID){
        communication {
            validateDynamicText(id: $id, context: $context, dictionaryToValidate: $dictionaryToValidate, participantID: $participantID){
                key,
                errors{
                    type,
                    message,
                    property,
                    errorLine
                }
            }
        }
    }
`;
